import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import SvgIcon from '@mui/material/SvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function CoinsIcon(props) {
  return /*#__PURE__*/_jsxs(SvgIcon, _objectSpread(_objectSpread({
    viewBox: "0 0 500 500"
  }, props), {}, {
    "data-element": "SvgIcon",
    "data-component": "CoinsIcon",
    "data-source-file": "coins.tsx",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M312.5,166.7c-80.5,0-145.8,65.3-145.8,145.8S232,458.3,312.5,458.3c80.5,0,145.8-65.3,145.8-145.8S393,166.7,312.5,166.7 z M365.1,322.1l-25,13.7c-1.8,1-3.3,2.5-4.3,4.3l-13.7,25c-4.1,7.6-15,7.6-19.1,0l-13.7-25c-1-1.8-2.5-3.3-4.3-4.3l-25-13.7 c-7.6-4.1-7.6-15,0-19.1l25-13.7c1.8-1,3.3-2.5,4.3-4.3l13.7-25c4.1-7.6,15-7.6,19.1,0l13.7,25c1,1.8,2.5,3.3,4.3,4.3l25,13.7 C372.7,307.1,372.7,317.9,365.1,322.1z",
      "data-element": "path",
      "data-component": "CoinsIcon",
      "data-source-file": "coins.tsx"
    }), /*#__PURE__*/_jsx("path", {
      d: "M168.1,193c35.8-43.2,88.4-68,144.5-68c2.3,0,4.5,0.2,6.8,0.3C299.9,84.2,261.6,53,216,44.4 C113.3,24.9,24.9,113.3,44.4,216.1c8.7,45.6,39.9,83.9,81.1,103.3C123.9,273.4,138.6,228.5,168.1,193z",
      "data-element": "path",
      "data-source-file": "coins.tsx"
    })]
  }));
}